module.exports = __webpack_public_path__ + "static/media/narciso-rodriguez-poudree-big.c3bd02c4.png";